import React from 'react'
import { Link } from 'react-router-dom'

export default function Header() {
  return (
    <header>
        <div className="header-stripe">
            <div className="header-stripe-content">
                <img src="./images/external-link.png" alt="" height="22" />
                &nbsp;&nbsp;<a href="https://www.mirumpharma.com" target="_blank" aria-label="Link to Mirum Pharma (opens in a new window)" title="Mirum Pharma (opens in a new window)">www.mirumpharma.com</a>
            </div>
        </div>

        <div className="header-content">
            <div className="flex-item">
                <Link to="/" title="Home">
                <img className="header-logo" src="./images/logo-mirum.png" alt="Mirum Libray home" align="absmiddle" />
                </Link>
            </div>

        </div>
    </header>
  )
}
